// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageInput_root__18KVM","image":"ImageInput_image__IJz5e","delete":"ImageInput_delete__2IFj6"};